import { type ReactElement } from 'react'
import { DemoProvider } from './state/store.js'
import { useStep } from './state/useStep.js'
import { SCREENS } from './screens/registry.js'
import { ErrorBoundary } from './components/ErrorBoundary.js'
import { BrowserTransition } from './components/BrowserTransition.js'

const Router = (): ReactElement => {
  const { step } = useStep()
  const Screen = SCREENS[step]
  console.log(`[router] rendering step=${step}`)
  return <Screen />
}

export const App = (): ReactElement => {
  return (
    <ErrorBoundary>
      <DemoProvider>
        <Router />
        <BrowserTransition />
      </DemoProvider>
    </ErrorBoundary>
  )
}
